//Get Events
export const GET_EVENTS_REQUEST = "GET_EVENTS_REQUEST";
export const GET_EVENTS_RECEIVE = "GET_EVENTS_RECEIVE";